import { AxiosResponse } from 'axios';
import { auditList } from '@/api/audit';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IAuditApiListResponse, IAuditFilters } from '@/types/audit';

export const auditService = {
    async list(params: IListParams<IAuditFilters>): Promise<AxiosResponse<IAuditApiListResponse>> {
        try {
            return await baseListService<IAuditApiListResponse>(auditList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Audit API Error:', e);
            throw new AppError('Unable to load audit list, request error', { cause: e });
        }
    },
};
